






























































































































import Vue from 'vue';
import FormMixin from '@/mixins/formMixin';
import Customer from '@/models/Customer';

export default Vue.extend({
	name: 'AdditionalFieldsForm',

	mixins: [FormMixin],

	props: {
		additionalFields: {} as () => Locations.AdditionalField[],
		type: {
			type: String,
			default: '',
		},
		value: Object,
	},

	computed: {
		hasFields(): boolean {
			return this.settings.collect_discount
				|| this.settings.recurring_promo
				|| this.additionalFields.length;
		},

		model: {
			get(): Customer {
				return this.value;
			},
			set(value: Customer) {
				this.$nextTick(() => {
					this.$emit('input', value);
				});
			},
		},

		settings(): Locations.Settings {
			return this.$store.getters['location/settings'];
		},
	},
});
